import template from './questionCheckAndIcon.html';
import './style.scss';

export default {
  template,
  controllerAs: 'vm',
  bindings: {
    titleValue: '<',
    inputValue: '<',
    iconText: '@',
    placeHolder: '@',
    onChange: '&',
  },
};
